import React from 'react';

const SectionDesc = ({ children }) => <p className="integrationsPortal-section-desc">{children}</p>;

export default SectionDesc;
